module.exports = __webpack_public_path__ + "img/thumbnail_AntilleanIguana_u_albino.8e3dfb7e.png";